import { render, staticRenderFns } from "./PasswordChangePage.vue?vue&type=template&id=8c808460&scoped=true&"
import script from "./PasswordChangePage.vue?vue&type=script&lang=js&"
export * from "./PasswordChangePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c808460",
  null
  
)

export default component.exports